<template>
  <k-page class="page-settings-starts-categories">
    <the-settings-starts-categories />
  </k-page>
</template>

<script>
/**
 * Component: page-settings-starts-categories - Страница настроек категорий забегов
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheSettingsStartsCategories from '@/components/TheSettingsStartsCategories.vue';


export default {
  name: 'page-settings-starts-categories',

  components: {
    KPage,
    TheSettingsStartsCategories,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-settings-starts-categories {
  $this: &;
}
</style>
